
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("35RMv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $3e6Uc = parcelRequire("3e6Uc");


var $3tMMZ = parcelRequire("3tMMZ");


var $frIzR = parcelRequire("frIzR");





var $1imNS = parcelRequire("1imNS");


var $82dFP = parcelRequire("82dFP");


var $hsPNq = parcelRequire("hsPNq");




/**
 * @generated SignedSource<<40f758399a1db75d5066e530c78a72b5>>
 * @relayHash fa50d8b3852c56d36be7fac088a9ba4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2cf5ca59f5fab81de5551e1672c3a44fdf58e60691c68a086935b3b0e044502e
const $5948691bb42cc4e0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "CompanyHubTopNavigationQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "CompanyHubTopNavigationQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "fa50d8b3852c56d36be7fac088a9ba4e",
            "id": "2cf5ca59f5fab81de5551e1672c3a44fdf58e60691c68a086935b3b0e044502e",
            "metadata": {},
            "name": "CompanyHubTopNavigationQuery",
            "operationKind": "query",
            "text": "query CompanyHubTopNavigationQuery{user:confluence_atlassianUser(current:true){id,emails{value,isPrimary}}}"
        }
    };
}();
$5948691bb42cc4e0$var$node.hash = "238c0250fbd01b632929613e283475f3";
var $5948691bb42cc4e0$export$2e2bcd8739ae039 = $5948691bb42cc4e0$var$node;






var $dTIqH = parcelRequire("dTIqH");

var $idPUB = parcelRequire("idPUB");

var $9vGun = parcelRequire("9vGun");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $e4o8D = parcelRequire("e4o8D");


var $eBBZq = parcelRequire("eBBZq");


var $1B659 = parcelRequire("1B659");


var $3yPEN = parcelRequire("3yPEN");


var $9MAeh = parcelRequire("9MAeh");


var $cAMBp = parcelRequire("cAMBp");


var $eDVeb = parcelRequire("eDVeb");

/**
 * @generated SignedSource<<51f23cf87311b658889d225ea3fae633>>
 * @relayHash bf87e192c54f91a66ced771e71a83e95
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ff79aed9b86267ef2c6a6d3832ae25239618cb8d60cf74d7f9c27d6ee131c3c6
const $73f7a19eb9ba164e$var$node = function() {
    var v0 = [
        {
            "concreteType": "LookAndFeelSettings",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LookAndFeel",
                    "kind": "LinkedField",
                    "name": "custom",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HeaderLookAndFeel",
                            "kind": "LinkedField",
                            "name": "horizontalHeader",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundColor"
                                },
                                {
                                    "concreteType": "NavigationLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "primaryNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "highlightColor"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "SiteConfiguration",
            "kind": "LinkedField",
            "name": "siteConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "customSiteLogo"
                }
            ]
        },
        {
            "concreteType": "SiteSettings",
            "kind": "LinkedField",
            "name": "siteSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "siteTitle"
                },
                {
                    "kind": "ScalarField",
                    "name": "showApplicationTitle"
                }
            ]
        },
        {
            "concreteType": "SiteDescription",
            "kind": "LinkedField",
            "name": "siteDescription",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "logoUrl"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "AppNavigationUnifiedQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "AppNavigationUnifiedQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "bf87e192c54f91a66ced771e71a83e95",
            "id": "ff79aed9b86267ef2c6a6d3832ae25239618cb8d60cf74d7f9c27d6ee131c3c6",
            "metadata": {},
            "name": "AppNavigationUnifiedQuery",
            "operationKind": "query",
            "text": "query AppNavigationUnifiedQuery{lookAndFeel{custom{horizontalHeader{backgroundColor,primaryNavigation{highlightColor}}}},siteConfiguration{customSiteLogo},siteSettings{siteTitle,showApplicationTitle},siteDescription{logoUrl},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary},confluence{permissionType}}}"
        }
    };
}();
$73f7a19eb9ba164e$var$node.hash = "619f7ed5bf8c55063c547ebd35234b66";
var $73f7a19eb9ba164e$export$2e2bcd8739ae039 = $73f7a19eb9ba164e$var$node;









var $l998X = parcelRequire("l998X");

parcelRequire("42omo");




parcelRequire("42omo");




parcelRequire("42omo");


var $9ML05 = parcelRequire("9ML05");


var $ilSNM = parcelRequire("ilSNM");


var $hoiF1 = parcelRequire("hoiF1");


var $lSGOy = parcelRequire("lSGOy");

const $739c14dbd5941201$export$5e6158d2118ae4aa = ({ testId: testId, logInLink: logInLink })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $9ML05.Profile), {
        testId: testId,
        href: logInLink,
        onClick: (event, analytics)=>{
            analytics.update({
                actionSubjectId: 'logInLink'
            }).fire((0, $hoiF1.NAVIGATION_CHANNEL));
        },
        tooltip: (0, $lSGOy.logInTooltip),
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ilSNM))), {
            color: "currentColor",
            label: ""
        })
    });


/* nav3.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $aXWIB = parcelRequire("aXWIB");





var $4wwVl = parcelRequire("4wwVl");


var $asAwU = parcelRequire("asAwU");


var $lGKVd = parcelRequire("lGKVd");

const $84a2e3c47e22a026$var$imgStyles = null; // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
const $84a2e3c47e22a026$export$89d857133932d6aa = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ picture: picture, email: email, trustPicture: trustPicture = false, ...props }, ref)=>{
    const intl = (0, $aXWIB.useIntl)();
    const state = (0, $asAwU.useImageState)(picture || '');
    const tooltip = intl.formatMessage((0, $lGKVd.messages).triggerTooltip);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9ML05.Profile), {
        ...props,
        ref: ref,
        tooltip: email || tooltip,
        icon: picture && (trustPicture || state === 'loaded') ? /*#__PURE__*/ (0, $l998X.jsx)("img", {
            src: picture,
            alt: tooltip,
            className: (0, $gMc0m.default)([
                "_2rko1rr0 _1bsb1ejb _4t3i1ejb"
            ])
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4wwVl))), {
            color: "currentColor",
            label: tooltip,
            spacing: "spacious"
        })
    });
});



var $4mshv = parcelRequire("4mshv");

const $a5cc9a5330823789$export$4ff56e5cf713dc64 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4mshv.AccountMenu), {
        ...props,
        AccountMenuLoggedOutState: (0, $739c14dbd5941201$export$5e6158d2118ae4aa),
        AccountMenuTrigger: (0, $84a2e3c47e22a026$export$89d857133932d6aa)
    });
};





parcelRequire("42omo");

/**
 * An Identity environment to integrate with. Either a `"dev"`, `"fedex"`, `"staging"` or
 * `"prod"` for real Identity environments, or an `EnvironmentConfig` object for
 * using a fake environment (e.g. for local dev).
 */ const $f3b592ea0eca1596$var$environmentConfigs = {
    dev: {
        baseUrl: 'https://id.dev.internal.atlassian.com'
    },
    fedex: {
        baseUrl: 'https://id.atlassian-fex.com'
    },
    staging: {
        baseUrl: 'https://id.stg.internal.atlassian.com'
    },
    'staging-fedramp-moderate': {
        baseUrl: 'https://id.stg.atlassian-us-gov-mod.com'
    },
    prod: {
        baseUrl: 'https://id.atlassian.com'
    },
    'prod-fedramp-moderate': {
        baseUrl: 'https://id.atlassian-us-gov-mod.com'
    }
};
function $f3b592ea0eca1596$export$eabfcea451f48b90(identityEnvironment) {
    if (typeof identityEnvironment === 'string') return $f3b592ea0eca1596$var$environmentConfigs[identityEnvironment];
    else return identityEnvironment;
}


/**
 * Helper function to create a string of custom query parameters
 * Returns a string like "&orgId=blah&..." that can be appended to URLs
 */ const $3e5c2e4c7ed97548$var$createCustomParametersString = (customParameters)=>{
    if (!customParameters || Object.keys(customParameters).length === 0) return '';
    return Object.entries(customParameters).map(([key, value])=>`&${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('');
};
const $3e5c2e4c7ed97548$var$buildProfileLink = (baseUrl, path, applicationParam, email, logInLinkCustomParameters)=>{
    const profileUrl = `${baseUrl}${path}`;
    if (email) {
        const logInLinkCustomParamsString = $3e5c2e4c7ed97548$var$createCustomParametersString(logInLinkCustomParameters);
        const loginUrl = `${baseUrl}/login?${applicationParam}&continue=${encodeURIComponent(profileUrl)}&prompt=none&login_hint=${encodeURIComponent(email)}${logInLinkCustomParamsString}`;
        return loginUrl;
    }
    return profileUrl;
};
function $3e5c2e4c7ed97548$export$2afde6c526be23b9({ email: email, identityEnvironment: identityEnvironment, application: application, continueUrl: continueUrl, logOutContinueUrl: logOutContinueUrl, isLoggedOut: isLoggedOut, disableSwitchAccountLink: disableSwitchAccountLink, logInLinkCustomParameters: logInLinkCustomParameters }) {
    const { baseUrl: baseUrl } = (0, $f3b592ea0eca1596$export$eabfcea451f48b90)(identityEnvironment);
    const applicationParam = `application=${encodeURIComponent(application)}`;
    const continueParam = `continue=${encodeURIComponent(continueUrl)}`;
    const logOutContinueParam = logOutContinueUrl ? `continue=${encodeURIComponent(logOutContinueUrl)}` : continueParam;
    const manageProfileLink = $3e5c2e4c7ed97548$var$buildProfileLink(baseUrl, '/manage-profile', applicationParam, email, logInLinkCustomParameters);
    return {
        manageProfileLink: manageProfileLink,
        switchAccountLink: disableSwitchAccountLink ? undefined : `${baseUrl}/login?${applicationParam}&${continueParam}&prompt=select_account${$3e5c2e4c7ed97548$var$createCustomParametersString(logInLinkCustomParameters)}`,
        logOutLink: `${baseUrl}/logout?${applicationParam}&${logOutContinueParam}` + (disableSwitchAccountLink ? '' : '&prompt=none'),
        logInLink: isLoggedOut ? `${baseUrl}/login?${applicationParam}&${continueParam}${$3e5c2e4c7ed97548$var$createCustomParametersString(logInLinkCustomParameters)}` : undefined
    };
}


const $507d7686e270e70a$export$df97669773647652 = ({ identityEnvironment: identityEnvironment, application: application, continueUrl: continueUrl, logOutContinueUrl: logOutContinueUrl, isLoggedOut: isLoggedOut, disableSwitchAccountLink: disableSwitchAccountLink, AccountMenu: AccountMenu, ...props })=>{
    const links = (0, $3e5c2e4c7ed97548$export$2afde6c526be23b9)({
        email: props.email,
        identityEnvironment: identityEnvironment,
        application: application,
        continueUrl: continueUrl,
        logOutContinueUrl: logOutContinueUrl,
        isLoggedOut: isLoggedOut,
        disableSwitchAccountLink: disableSwitchAccountLink
    });
    return /*#__PURE__*/ (0, $l998X.jsx)(AccountMenu, {
        ...props,
        ...links
    });
};


const $e59175270654f550$export$75dc45130eee4ebb = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $507d7686e270e70a$export$df97669773647652), {
        ...props,
        AccountMenu: (0, $a5cc9a5330823789$export$4ff56e5cf713dc64)
    });
};



var $7J5Uc = parcelRequire("7J5Uc");





var $9wGTI = parcelRequire("9wGTI");


var $ictHB = parcelRequire("ictHB");


var $disnP = parcelRequire("disnP");

const $41e938af2c9a6719$var$ENV_TO_IDENTITY_ENV = {
    STAGING: 'staging',
    DEVELOPMENT: 'dev',
    PRODUCTION: 'prod'
};
const $41e938af2c9a6719$export$b3f2b8c6cd294d68 = (env)=>$41e938af2c9a6719$var$ENV_TO_IDENTITY_ENV[env] || 'prod';


const $318a934f5d964bb7$export$6602717775dd2fda = (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { user: user } = t0;
    const [themeState, themingActions] = (0, $7J5Uc.useThemingState)();
    let t1;
    if ($[0] !== user.id) {
        t1 = ()=>(0, $ictHB.fetchGlobalColorMode)(user.id);
        $[0] = user.id;
        $[1] = t1;
    } else t1 = $[1];
    const getThemePreference = t1;
    const [globalColorMode, loadGlobalColorModeOnce] = (0, $disnP.useColorModeState)(getThemePreference, user.id);
    let t2;
    if ($[2] !== user.environment) {
        t2 = (0, $41e938af2c9a6719$export$b3f2b8c6cd294d68)(user.environment);
        $[2] = user.environment;
        $[3] = t2;
    } else t2 = $[3];
    const identityEnvironment = t2;
    let t3;
    if ($[4] !== user.emails) {
        t3 = user?.emails?.find($318a934f5d964bb7$var$_temp)?.value || "";
        $[4] = user.emails;
        $[5] = t3;
    } else t3 = $[5];
    const primaryEmail = t3;
    const displayName = user?.displayName || "";
    let t4;
    if ($[6] !== user.photos) {
        t4 = user?.photos?.find($318a934f5d964bb7$var$_temp2)?.value || "";
        $[6] = user.photos;
        $[7] = t4;
    } else t4 = $[7];
    const photo_0 = t4;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const continueUrl = !renderServerPlaceholder && typeof window !== "undefined" ? window.location.href : "";
    let t5;
    if ($[8] !== globalColorMode) {
        t5 = (0, $9wGTI.fg)("shared-user-preferences") ? globalColorMode : undefined;
        $[8] = globalColorMode;
        $[9] = t5;
    } else t5 = $[9];
    const t6 = themeState?.theme?.colorMode;
    let t7;
    if ($[10] !== continueUrl || $[11] !== displayName || $[12] !== identityEnvironment || $[13] !== loadGlobalColorModeOnce || $[14] !== photo_0 || $[15] !== primaryEmail || $[16] !== t5 || $[17] !== t6 || $[18] !== themingActions.setColorModePreference) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e59175270654f550$export$75dc45130eee4ebb), {
            globalColorMode: t5,
            onThemeSwitcherOpenChange: loadGlobalColorModeOnce,
            testId: "company-hub-profile-button",
            application: "confluence",
            email: primaryEmail,
            identityEnvironment: identityEnvironment,
            continueUrl: continueUrl,
            name: displayName,
            picture: photo_0,
            currentTheme: t6,
            onThemeChange: themingActions.setColorModePreference
        });
        $[10] = continueUrl;
        $[11] = displayName;
        $[12] = identityEnvironment;
        $[13] = loadGlobalColorModeOnce;
        $[14] = photo_0;
        $[15] = primaryEmail;
        $[16] = t5;
        $[17] = t6;
        $[18] = themingActions.setColorModePreference;
        $[19] = t7;
    } else t7 = $[19];
    return t7;
};
function $318a934f5d964bb7$var$_temp(email) {
    return email?.isPrimary;
}
function $318a934f5d964bb7$var$_temp2(photo) {
    return photo?.isPrimary;
}









var $lAFHW = parcelRequire("lAFHW");


var $1s5hv = parcelRequire("1s5hv");


var $iG5N1 = parcelRequire("iG5N1");


var $63PsI = parcelRequire("63PsI");


var $1NBp8 = parcelRequire("1NBp8");

const $148e6fa056eafe7e$export$cab7880b110e6025 = ()=>{
    const $ = (0, $frIzR.c)(3);
    const companyHubName = (0, $63PsI.useCompanyHubName)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $1NBp8.COMPANY_HUB).toUrl();
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== companyHubName) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iG5N1.CustomLogo), {
            href: t0,
            icon: $148e6fa056eafe7e$var$CompanyHubNavIcon,
            label: companyHubName,
            logo: $148e6fa056eafe7e$var$CompanyHubLogo
        });
        $[1] = companyHubName;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
/**
 * The navigation logo at small viewport widths.
 */ const $148e6fa056eafe7e$var$CompanyHubNavIcon = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.HubIcon), {
            size: "small",
            shouldUseNewLogoDesign: true
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
/**
 * The navigation logo at large viewport widths.
 */ function $148e6fa056eafe7e$var$CompanyHubLogo() {
    const $ = (0, $frIzR.c)(10);
    const companyHubName = (0, $63PsI.useCompanyHubName)();
    const textRef = (0, $42omo.useRef)(null);
    const [textWidth, setTextWidth] = (0, $42omo.useState)(0);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (textRef.current) {
                const nameTextBox = textRef.current.getBBox();
                setTextWidth(nameTextBox.width);
            }
        };
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== companyHubName) {
        t1 = [
            companyHubName
        ];
        $[1] = companyHubName;
        $[2] = t1;
    } else t1 = $[2];
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.HubIcon), {
            size: "small",
            shouldUseNewLogoDesign: true
        });
        $[3] = t2;
    } else t2 = $[3];
    const t3 = `0 0 ${textWidth} 32`;
    let t4;
    if ($[4] !== companyHubName) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("text", {
            ref: textRef,
            dominantBaseline: "central",
            x: "0",
            y: "50%",
            fill: "var(--ds-text, #292A2E)",
            fontFamily: "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            fontSize: "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }, companyHubName);
        $[4] = companyHubName;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4 || $[8] !== textWidth) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            gap: "space.075",
            alignItems: "center"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: textWidth,
            height: "32",
            viewBox: t3
        }, t4));
        $[6] = t3;
        $[7] = t4;
        $[8] = textWidth;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
}



var $jMyy4 = parcelRequire("jMyy4");

/**
 * The top navigation of the Company Hub app-like experience at Team '25 US.
 *
 * Inspired by `TopNavigation` at confluence/next/packages/app-navigation/src/TopNavigation.tsx
 *
 * @see {@link https://www.figma.com/design/MBdUXhdmgbsIkMkOhQGu5e/Hub-App?node-id=101-52260}
 * @see {@link https://hello.atlassian.net/wiki/spaces/CLI/pages/4856024337/Confluence-less+Team+25+US+Experience}
 */ function $abe171926f0f789f$var$CompanyHubTopNavigationComponent() {
    const $ = (0, $frIzR.c)(41);
    const { displayName: displayName, isLoggedIn: isLoggedIn, environment: environment } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t0;
    if ($[0] !== renderServerPlaceholder) {
        t0 = {
            skip: renderServerPlaceholder
        };
        $[0] = renderServerPlaceholder;
        $[1] = t0;
    } else t0 = $[1];
    const { data: emailData, error: emailError } = (0, $jMyy4.useQueryInterop)((0, $5948691bb42cc4e0$export$2e2bcd8739ae039), {
        ...t0,
        __callerPackage__: "@confluence/app-navigation"
    });
    const isAtlassianStaff = $abe171926f0f789f$var$_temp2;
    const { data: photoData, error: photoError } = (0, $jMyy4.useQueryInterop)((0, $73f7a19eb9ba164e$export$2e2bcd8739ae039), {
        __callerPackage__: "@confluence/app-navigation"
    });
    const t1 = emailData?.user?.id ?? null;
    const t2 = photoData?.user?.photos ?? null;
    const t3 = emailData?.user?.emails ?? null;
    let T0;
    let T1;
    let renderError;
    let t4;
    let t5;
    let t6;
    let user_0;
    if ($[2] !== displayName || $[3] !== environment || $[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
        user_0 = {
            id: t1,
            displayName: displayName,
            photos: t2,
            emails: t3,
            environment: environment
        };
        renderError = $abe171926f0f789f$var$_temp3;
        T1 = (0, $9vGun.TopNavStart);
        t5 = null;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eBBZq.AppSwitcherButton), null);
            $[14] = t6;
        } else t6 = $[14];
        T0 = (0, $1B659.DeveloperButtons);
        t4 = isAtlassianStaff(user_0);
        $[2] = displayName;
        $[3] = environment;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
        $[7] = T0;
        $[8] = T1;
        $[9] = renderError;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = user_0;
    } else {
        T0 = $[7];
        T1 = $[8];
        renderError = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        user_0 = $[13];
    }
    let t7;
    if ($[15] !== T0 || $[16] !== t4) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            isAtlassianStaff: t4
        });
        $[15] = T0;
        $[16] = t4;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $148e6fa056eafe7e$export$cab7880b110e6025), null);
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== T1 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T1, {
            sideNavToggleButton: t5
        }, t6, t7, t8);
        $[19] = T1;
        $[20] = t5;
        $[21] = t6;
        $[22] = t7;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $idPUB.TopNavMiddle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eDVeb.SearchBar), null));
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    let t12;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cAMBp.RovoButton), null);
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MAeh.NotificationsButton), null);
        $[25] = t11;
        $[26] = t12;
    } else {
        t11 = $[25];
        t12 = $[26];
    }
    let t13;
    if ($[27] !== isLoggedIn || $[28] !== user_0) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dTIqH.TopNavEnd), null, t11, t12, isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $318a934f5d964bb7$export$6602717775dd2fda), {
            user: user_0
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3yPEN.LoginButton), null));
        $[27] = isLoggedIn;
        $[28] = user_0;
        $[29] = t13;
    } else t13 = $[29];
    let t14;
    if ($[30] !== emailError || $[31] !== renderError) {
        t14 = emailError && renderError(emailError);
        $[30] = emailError;
        $[31] = renderError;
        $[32] = t14;
    } else t14 = $[32];
    let t15;
    if ($[33] !== photoError || $[34] !== renderError) {
        t15 = photoError && renderError(photoError);
        $[33] = photoError;
        $[34] = renderError;
        $[35] = t15;
    } else t15 = $[35];
    let t16;
    if ($[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== t9) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t9, t10, t13, t14, t15);
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = t9;
        $[40] = t16;
    } else t16 = $[40];
    return t16;
}
function $abe171926f0f789f$var$_temp3(error) {
    if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error)) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
}
function $abe171926f0f789f$var$_temp2(user) {
    return user?.emails?.some($abe171926f0f789f$var$_temp) || false;
}
function $abe171926f0f789f$var$_temp(email) {
    return email?.value && (email.value.endsWith("@atlassian.com") || email.value.endsWith("@atlassian.com.invalid") || email.value.endsWith("@usersinbuckets.com"));
}
const $abe171926f0f789f$export$ed6ca7f2734173e6 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING,
    attributes: {
        // Inspired by `TopNavigationBase` at confluence/next/packages/app-navigation/entry-points/topNavigation.tsx
        errorBoundaryId: 'company-hub/top-navigation'
    }
})($abe171926f0f789f$var$CompanyHubTopNavigationComponent);









var $4PPzL = parcelRequire("4PPzL");


var $jln20 = parcelRequire("jln20");


var $lpfM9 = parcelRequire("lpfM9");

/**
 * The {@link https://staging.atlassian.design/components/navigation-system/page-layout/examples | page layout} of the Company Hub app-like experience at Team '25 US.
 *
 * Inspired by `PageLayout` at confluence/next/packages/page-layout/src/PageLayout.tsx
 *
 * @see {@link https://www.figma.com/design/MBdUXhdmgbsIkMkOhQGu5e/Hub-App?node-id=101-52260}
 * @see {@link https://hello.atlassian.net/wiki/spaces/CLI/pages/4856024337/Confluence-less+Team+25+US+Experience}
 */ const $cedecc811b46b190$var$CompanyHubPageLayoutComponent = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hsPNq.TopNav), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abe171926f0f789f$export$ed6ca7f2734173e6), null));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            errorBoundaryId: "company-hub/page-layout/children"
        };
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1imNS.Main), {
            id: "AkMainContent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING,
            attributes: t2
        }, children));
        $[2] = children;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lpfM9.PanelLoader), {
            toggleInProductHelp: $cedecc811b46b190$var$_temp
        });
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jln20.RightSidebarContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82dFP.Root), {
            UNSAFE_dangerouslyHoistSlotSizes: true
        }, t1, t3, t4));
        $[5] = t3;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
};
const $cedecc811b46b190$export$de31e0f91c524d8f = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING,
    attributes: {
        // Inspired by `PageLayout` and `PageLayoutInner` at confluence/next/packages/page-layout/src/PageLayout.tsx
        errorBoundaryId: 'company-hub/page-layout'
    }
})($cedecc811b46b190$var$CompanyHubPageLayoutComponent);
function $cedecc811b46b190$var$_temp() {}



var $6mKj3 = parcelRequire("6mKj3");


var $9HB34 = parcelRequire("9HB34");




const $8192fec6448579e6$var$relayEnvironment = new (0, $3e6Uc.Environment)((0, $3tMMZ.getDefaultRelayEnvironmentConfig)({}));
const $8192fec6448579e6$export$bbf3d8e57337c75 = ({ children: children })=>{
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cedecc811b46b190$export$de31e0f91c524d8f), null, children);
    return (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) || (0, $9wGTI.fg)('navx-global-side-nav-confluence') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irOoi.RelayEnvironmentProvider), {
        environment: (0, $9wGTI.fg)('cfe_use_confluence_relay_env') ? (0, $9HB34.getRelayEnvironment)() : $8192fec6448579e6$var$relayEnvironment
    }, content) : content;
};
module.exports["CompanyHubMainLayout"] = $8192fec6448579e6$export$bbf3d8e57337c75;

});

parcelRegister("63PsI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1ytiN = parcelRequire("1ytiN");

function $acec4613ff860ea3$export$e7c489d818076f3d() {
    let { companyHubName: companyHubName } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const intl = (0, $aXWIB.useIntl)();
    if (!companyHubName) companyHubName = intl.formatMessage($acec4613ff860ea3$var$messages.defaultCompanyHubName);
    return companyHubName;
}
// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages -- Moved from confluence/next/packages/app-navigation/src/Nav3/PrimaryItems/CompanyHubItem.tsx
const $acec4613ff860ea3$var$messages = (0, $aXWIB.defineMessages)({
    defaultCompanyHubName: {
        id: "app-navigation.company-hub.link",
        defaultMessage: "Company hub"
    }
});
module.exports["useCompanyHubName"] = $acec4613ff860ea3$export$e7c489d818076f3d;

});

parcelRegister("jln20", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("lpfM9", function(module, exports) {

var $fwDOR = parcelRequire("fwDOR");


var $jmjWc = parcelRequire("jmjWc");

const $d8af34c11b1c225c$var$createLoadingComponent = ()=>{
    return (0, $fwDOR.default)({
        name: 'LoadingConfluenceRightPanelBundle'
    });
};

const $d8af34c11b1c225c$export$bec010aa49373196 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mQOM4",
    name: "PanelLoader",
    loader: async ()=>(await (parcelRequire("9qSKR"))).RightPanel,
    loading: $d8af34c11b1c225c$var$createLoadingComponent
});
module.exports["PanelLoader"] = $d8af34c11b1c225c$export$bec010aa49373196;

});

parcelRegister("9qSKR", function(module, exports) {

let $6de103f2e65cea7f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6de103f2e65cea7f$var$load("7TbZ2"),
    $6de103f2e65cea7f$var$load("4iy7m"),
    $6de103f2e65cea7f$var$load("6wr18"),
    $6de103f2e65cea7f$var$load("5UCxV"),
    $6de103f2e65cea7f$var$load("dwSiO"),
    $6de103f2e65cea7f$var$load("2O2Xv"),
    $6de103f2e65cea7f$var$load("i3R6S"),
    $6de103f2e65cea7f$var$load("6pr2g"),
    $6de103f2e65cea7f$var$load("cmqxT"),
    $6de103f2e65cea7f$var$load("9ijrN"),
    $6de103f2e65cea7f$var$load("3BqWF"),
    $6de103f2e65cea7f$var$load("lGnwl"),
    $6de103f2e65cea7f$var$load("8Rc3a"),
    $6de103f2e65cea7f$var$load("3sb7M"),
    $6de103f2e65cea7f$var$load("lBu3j"),
    $6de103f2e65cea7f$var$load("37ldp"),
    $6de103f2e65cea7f$var$load("hhss7"),
    $6de103f2e65cea7f$var$load("cyGuT"),
    $6de103f2e65cea7f$var$load("ffEVr"),
    $6de103f2e65cea7f$var$load("6bVVs"),
    $6de103f2e65cea7f$var$load("7mo6o"),
    $6de103f2e65cea7f$var$load("cONk3"),
    $6de103f2e65cea7f$var$load("ltDLY"),
    $6de103f2e65cea7f$var$load("7EorR"),
    $6de103f2e65cea7f$var$load("Wowvf"),
    $6de103f2e65cea7f$var$load("etEYy"),
    $6de103f2e65cea7f$var$load("cvXSy")
]).then(()=>parcelRequire('8CeBV'));

});

parcelRegister("5G9KX", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $c4TO3 = parcelRequire("c4TO3");

const $34a6846e1e43ece9$export$5aa524d86254b4f = (key, value)=>{
    if ((0, $dh538.fg)('search_page_use_browser_storage_controls')) (0, $c4TO3.AtlBrowserStorageLocal).setItem(key, value);
    else localStorage.setItem(key, value);
};
const $34a6846e1e43ece9$export$93d719890ad66653 = (key)=>{
    const item = (0, $dh538.fg)('search_page_use_browser_storage_controls') ? (0, $c4TO3.AtlBrowserStorageLocal).getItem(key) : localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $34a6846e1e43ece9$export$5df15f289f441790 = (key)=>{
    const item = (0, $dh538.fg)('search_page_use_browser_storage_controls') ? (0, $c4TO3.AtlBrowserStorageLocal).getItem(key) : localStorage.getItem(key);
    return item ? item : null;
};
const $34a6846e1e43ece9$export$baf306891f1b93bd = (key)=>{
    if ((0, $dh538.fg)('search_page_use_browser_storage_controls')) (0, $c4TO3.AtlBrowserStorageLocal).removeItem(key);
    else localStorage.removeItem(key);
};
module.exports["setLocalStorageItem"] = $34a6846e1e43ece9$export$5aa524d86254b4f;
module.exports["getLocalStorageItem"] = $34a6846e1e43ece9$export$93d719890ad66653;
module.exports["getLocalStorageItemAsString"] = $34a6846e1e43ece9$export$5df15f289f441790;

});

parcelRegister("epLE5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $42omo.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("ghphD", function(module, exports) {
$parcel$export(module.exports, "default", () => $bda1d8a3686c6d03$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $jZ39j = parcelRequire("jZ39j");


var $b5utg = parcelRequire("b5utg");


var $2h3f7 = parcelRequire("2h3f7");

function $bda1d8a3686c6d03$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b5utg.default)(1, arguments);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var weekStartsOn = (0, $jZ39j.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("e0SBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33b6ba3d9a58f3b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $a33b6ba3d9a58f3b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("cStGJ", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $9K4OG = parcelRequire("9K4OG");


var $g2YHK = parcelRequire("g2YHK");


var $dStU0 = parcelRequire("dStU0");


var $dmgN7 = parcelRequire("dmgN7");


var $42omo = parcelRequire("42omo");


var $c58zA = parcelRequire("c58zA");

var $96018e9e3b3d2b35$var$isDevelopment = false;
var $96018e9e3b3d2b35$var$testOmitPropsOnStringTag = (0, $c58zA.default);
var $96018e9e3b3d2b35$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $96018e9e3b3d2b35$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $96018e9e3b3d2b35$var$testOmitPropsOnStringTag : $96018e9e3b3d2b35$var$testOmitPropsOnComponent;
};
var $96018e9e3b3d2b35$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $96018e9e3b3d2b35$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dmgN7.registerStyles)(cache, serialized, isStringTag);
    (0, $dStU0.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dmgN7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $96018e9e3b3d2b35$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $96018e9e3b3d2b35$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $9K4OG.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $42omo.useContext((0, $9K4OG.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $dmgN7.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $g2YHK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($96018e9e3b3d2b35$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $42omo.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $96018e9e3b3d2b35$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $7Q5yr.default)({}, options, nextOptions, {
                shouldForwardProp: $96018e9e3b3d2b35$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $96018e9e3b3d2b35$export$2e2bcd8739ae039;

});

parcelRegister("dStU0", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $a1a7838157a2757d$var$syncFallback = function syncFallback(create) {
    return create();
};
var $a1a7838157a2757d$var$useInsertionEffect = $42omo.useInsertionEffect ? $42omo.useInsertionEffect : false;
var $a1a7838157a2757d$export$db21c7ffa21794e7 = $a1a7838157a2757d$var$useInsertionEffect || $a1a7838157a2757d$var$syncFallback;
var $a1a7838157a2757d$export$811a713a7276cb9d = $a1a7838157a2757d$var$useInsertionEffect || $42omo.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $a1a7838157a2757d$export$db21c7ffa21794e7;

});

parcelRegister("c58zA", function(module, exports) {

var $9bLS2 = parcelRequire("9bLS2");

// eslint-disable-next-line no-undef
var $8cbc9a10962c1be8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8cbc9a10962c1be8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9bLS2.default)(function(prop) {
    return $8cbc9a10962c1be8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $8cbc9a10962c1be8$export$2e2bcd8739ae039;

});

parcelRegister("aMqwg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9d4cc27d6faf7a6e$var$rovoEntitlementStore = (0, $1P1Tu.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $9d4cc27d6faf7a6e$var$useStateHook = (0, $9zUhf.createStateHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$66d5dd4be64dea43 = ()=>{
    const result = $9d4cc27d6faf7a6e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $9d4cc27d6faf7a6e$export$8004893135276275 = (0, $9zUhf.createActionsHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $9d4cc27d6faf7a6e$export$8004893135276275();
    (0, $42omo.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $9d4cc27d6faf7a6e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $9d4cc27d6faf7a6e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $9d4cc27d6faf7a6e$export$d03a05ad8547472c;

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($26d702ce000cc6e9$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId || !userId) return;
        $26d702ce000cc6e9$var$hasFetched = true;
        storeActions.start();
        $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");

var $cFEpk = parcelRequire("cFEpk");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $e0SBo.default)((0, $922yL.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $cFEpk.default)(cutoffDate) ? (0, $e0SBo.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("1cfhF", function(module, exports) {
const $bd349f0afc0f2270$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$6c053e1694ef181c = {
    prod: $bd349f0afc0f2270$export$31048cb2a0753b12,
    staging: $bd349f0afc0f2270$export$9d8f18312db80469
};
const $bd349f0afc0f2270$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};
module.exports["FIRST_PARTY_CCP_PRODUCT_IDS"] = $bd349f0afc0f2270$export$6c053e1694ef181c;
module.exports["SURFACE_ANALYTICS_PRODUCT_MAP"] = $bd349f0afc0f2270$export$54e3fc09a2a3347a;

});

parcelRegister("lfQiY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1cfhF = parcelRequire("1cfhF");


var $kfKKN = parcelRequire("kfKKN");

function $d96a3db7fec61911$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $42omo.useRef)();
    const firedViewedUIEventId = (0, $42omo.useRef)();
    const mapToCcpProductKeys = (0, $42omo.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $42omo.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}
module.exports["useFireCrossFlowAnalyticsEvents"] = $d96a3db7fec61911$export$c2095165ae2bdcda;

});

parcelRegister("kfKKN", function(module, exports) {
const $f3fd7ff29ab4c819$export$c536a7e29a0739b8 = 'crossFlow';
var $f3fd7ff29ab4c819$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});
module.exports["CROSS_FLOW_CHANNEL"] = $f3fd7ff29ab4c819$export$c536a7e29a0739b8;
module.exports["eventTypes"] = $f3fd7ff29ab4c819$export$285f3d0989f9023f;

});

parcelRegister("2azjJ", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line no-barrel-files/no-barrel-files






const $5648f131343e99e5$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$5648f131343e99e5$var$AkGrid(multiplier * num),
        half: ()=>$5648f131343e99e5$var$AkGrid(0.5 * num),
        twice: ()=>$5648f131343e99e5$var$AkGrid(2 * num)
    });
const $5648f131343e99e5$export$85fc379452d91af0 = $5648f131343e99e5$var$AkGrid(1);
const $5648f131343e99e5$export$b9930dabfa4a3a3 = '56px';
const $5648f131343e99e5$export$f6af7620e8789c39 = '200px';
const $5648f131343e99e5$export$64d8573e83b64ff8 = '150px';
const $5648f131343e99e5$export$a3da89b899389ed8 = '780px';
const $5648f131343e99e5$export$ce4512df260a325a = 780;
const $5648f131343e99e5$export$a406031ed42c8e02 = '1130px';
const $5648f131343e99e5$export$e00021bea368c518 = $5648f131343e99e5$export$85fc379452d91af0.multiple(4);
const $5648f131343e99e5$export$30310ee354b45eb0 = $5648f131343e99e5$export$85fc379452d91af0.multiple(6);
module.exports["grid"] = $5648f131343e99e5$export$85fc379452d91af0;
module.exports["atlassianNavigationHeight"] = $5648f131343e99e5$export$b9930dabfa4a3a3;
module.exports["collapsedSearchInputWidth"] = $5648f131343e99e5$export$f6af7620e8789c39;
module.exports["dialogWidth"] = $5648f131343e99e5$export$a3da89b899389ed8;
module.exports["dialogPageTakeoverWidth"] = $5648f131343e99e5$export$ce4512df260a325a;
module.exports["dialogPageCentreWidth"] = $5648f131343e99e5$export$a406031ed42c8e02;
module.exports["inputFieldHeight"] = $5648f131343e99e5$export$e00021bea368c518;
module.exports["enlargedInputFieldHeight"] = $5648f131343e99e5$export$30310ee354b45eb0;

});

parcelRegister("1662I", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ccb09ee82030ea4$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $e0mB4 = parcelRequire("e0mB4");


var $6b5eb = parcelRequire("6b5eb");


var $b5utg = parcelRequire("b5utg");

var $0ccb09ee82030ea4$var$MILLISECONDS_IN_WEEK = 604800000;
function $0ccb09ee82030ea4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var diff = (0, $e0mB4.default)(date).getTime() - (0, $6b5eb.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $0ccb09ee82030ea4$var$MILLISECONDS_IN_WEEK) + 1;
}

});

parcelRegister("e0mB4", function(module, exports) {
$parcel$export(module.exports, "default", () => $a322980fc7bdc1cb$export$2e2bcd8739ae039);

var $ghphD = parcelRequire("ghphD");


var $b5utg = parcelRequire("b5utg");

function $a322980fc7bdc1cb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $ghphD.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});

parcelRegister("6b5eb", function(module, exports) {
$parcel$export(module.exports, "default", () => $47f7d34a77e920df$export$2e2bcd8739ae039);

var $3Klnc = parcelRequire("3Klnc");


var $e0mB4 = parcelRequire("e0mB4");


var $b5utg = parcelRequire("b5utg");

function $47f7d34a77e920df$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var year = (0, $3Klnc.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $e0mB4.default)(fourthOfJanuary);
    return date;
}

});

parcelRegister("3Klnc", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ba63f43afaf9481$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $e0mB4 = parcelRequire("e0mB4");


var $b5utg = parcelRequire("b5utg");

function $2ba63f43afaf9481$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $e0mB4.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $e0mB4.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});

parcelRegister("7DldS", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f2cdb4cb36c37cab$export$bc9ec39841ba8fd3 = {
    CHAT: 'chat',
    SEARCH_QF_PILL: 'search-qf-connect-apps-pill',
    SEARCH_SIDEBAR: 'search-app-filter-sidebar'
};
const $f2cdb4cb36c37cab$export$ec3ac09cbc485f99 = (surface)=>surface?.startsWith('search-') === true;
const $f2cdb4cb36c37cab$var$initialState = {
    product: '',
    siteId: '',
    experienceId: 'ai-mate',
    assistanceServiceConfig: undefined,
    surface: undefined
};
const $f2cdb4cb36c37cab$var$rovoSettingsConfig = /*#__PURE__*/ (0, $42omo.createContext)($f2cdb4cb36c37cab$var$initialState);
const $f2cdb4cb36c37cab$export$e6e0575f100c37ab = $f2cdb4cb36c37cab$var$rovoSettingsConfig.Provider;
const $f2cdb4cb36c37cab$export$db68c798d50f727e = ()=>(0, $42omo.useContext)($f2cdb4cb36c37cab$var$rovoSettingsConfig);
module.exports["RovoSettingsModalSurface"] = $f2cdb4cb36c37cab$export$bc9ec39841ba8fd3;
module.exports["isSearchSurface"] = $f2cdb4cb36c37cab$export$ec3ac09cbc485f99;
module.exports["RovoSettingsConfigProvider"] = $f2cdb4cb36c37cab$export$e6e0575f100c37ab;
module.exports["useRovoSettingsConfig"] = $f2cdb4cb36c37cab$export$db68c798d50f727e;

});

parcelRegister("7ZiAi", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $c17fc71688854b9e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    modalTitle: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.modal-title.non-final",
        defaultMessage: "Sources & apps"
    },
    searchPlaceholder: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.search-placeholder.non-final",
        defaultMessage: "Search settings"
    },
    defaultTriggerLabel: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.default-trigger-label.non-final",
        defaultMessage: "Explore all apps"
    }
});
module.exports["messages"] = $c17fc71688854b9e$export$defe85febe8b728c;

});

parcelRegister("efXed", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $02aebea47caa4c41$export$d158fa15757a1890 = /*#__PURE__*/ (0, $42omo.createContext)(false);
function $02aebea47caa4c41$export$abfcaeeca4ae7a55() {
    return (0, $42omo.useContext)($02aebea47caa4c41$export$d158fa15757a1890);
}
module.exports["HasCustomThemeContext"] = $02aebea47caa4c41$export$d158fa15757a1890;
module.exports["useHasCustomTheme"] = $02aebea47caa4c41$export$abfcaeeca4ae7a55;

});

parcelRegister("lcVz9", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

function $6b6d58426e4ff3f5$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $6b6d58426e4ff3f5$var$IconRenderer = ({ icon: Icon })=>{
    const isRenderProp = $6b6d58426e4ff3f5$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $dh538.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            ...iconProps
        })
    });
};
var $6b6d58426e4ff3f5$export$2e2bcd8739ae039 = $6b6d58426e4ff3f5$var$IconRenderer;
module.exports["default"] = $6b6d58426e4ff3f5$export$2e2bcd8739ae039;

});

parcelRegister("i63G2", function(module, exports) {
/* themed-pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $dh538 = parcelRequire("dh538");


var $fVUfS = parcelRequire("fVUfS");


var $4jOXe = parcelRequire("4jOXe");

const $c0a568cbd64db8db$var$styles = {
    root: "_zulp12x7 _11c8fhey _2rkofajl _v5649dqc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    rootT26Shape: "_2rko1qi0",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m1j28 _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $c0a568cbd64db8db$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
const $c0a568cbd64db8db$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
}; /**
    * Props shared by `ThemedPressable` and `ThemedAnchor`
    */ 
const $c0a568cbd64db8db$export$66240319f1f78d74 = /*#__PURE__*/ (0, $42omo.forwardRef)(function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ...(0, $4jOXe.getPrimitiveSpreadProps)(props),
        ref: ref,
        type: "button",
        /**
                                                                                 * We are using some style values that are outside of the strict
                                                                                 * `@atlaskit/css` types.
                                                                                 */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $1bHXt.cx)($c0a568cbd64db8db$var$styles.root, (0, $dh538.fg)('platform-dst-shape-theme-default') && $c0a568cbd64db8db$var$styles.rootT26Shape, $c0a568cbd64db8db$var$shapeStyles[shape], hasBorder && $c0a568cbd64db8db$var$styles.border, $c0a568cbd64db8db$var$appearanceStyles[appearance], isSelected && $c0a568cbd64db8db$var$styles.selected, isDisabled && $c0a568cbd64db8db$var$styles.disabled),
        isDisabled: isDisabled
    });
});
module.exports["ThemedPressable"] = $c0a568cbd64db8db$export$66240319f1f78d74;

});

parcelRegister("4jOXe", function(module, exports) {
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ function $9048d266fac6ebf2$export$e4c95325a21f9785({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}
module.exports["getPrimitiveSpreadProps"] = $9048d266fac6ebf2$export$e4c95325a21f9785;

});

parcelRegister("3sMdn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $7p5xt = parcelRequire("7p5xt");


var $56M4r = parcelRequire("56M4r");


var $6F6hl = parcelRequire("6F6hl");


var $hmRr5 = parcelRequire("hmRr5");


var $4cUZH = parcelRequire("4cUZH");


var $dhBFe = parcelRequire("dhBFe");


var $kyRHQ = parcelRequire("kyRHQ");

/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $0affb4f68c8513c7$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $ee7An.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $kyRHQ;
    const [selected, setSelected] = (0, $4cUZH.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $42omo.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $dhBFe.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7p5xt.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                "aria-checked": selected,
                "aria-describedby": `${id}-radio`,
                description: description,
                iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $hmRr5.default), {
                    checked: selected
                }),
                id: id,
                isDisabled: isDisabled,
                isSelected: selected,
                onClick: onClickHandler,
                ref: itemRef,
                role: "menuitemradio",
                shouldDescriptionWrap: shouldDescriptionWrap,
                shouldTitleWrap: shouldTitleWrap,
                testId: testId,
                // Thanks to spread props, this attribute are passed to ButtonItem, even though
                // it's not in the component's prop types.
                // @ts-expect-error
                title: title,
                interactionName: interactionName,
                ...rest,
                // Override ButtonItem's default aria-current, as aria-checked is the correct attribute for menuitemradio (A11Y-37930)
                "aria-current": undefined,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6F6hl.default), {
                id: `${id}-radio`,
                children: [
                    "radio button ",
                    selected
                ]
            })
        ]
    });
};
var $0affb4f68c8513c7$export$2e2bcd8739ae039 = $0affb4f68c8513c7$var$DropdownItemRadio;
module.exports["default"] = $0affb4f68c8513c7$export$2e2bcd8739ae039;

});

parcelRegister("hmRr5", function(module, exports) {
/* radio-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $01850bf21ecc815c$var$svgStyles = null; /**
                         * __Radio icon__
                         *
                         * Used to visually represent the selected state in DropdownItemRadio
                         *
                         * @internal
                         */ 
const $01850bf21ecc815c$var$RadioIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "7.5",
                    fill: "currentColor",
                    stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
};
var $01850bf21ecc815c$export$2e2bcd8739ae039 = $01850bf21ecc815c$var$RadioIcon;
module.exports["default"] = $01850bf21ecc815c$export$2e2bcd8739ae039;

});

parcelRegister("4cUZH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mnSH = parcelRequire("6mnSH");


var $5g4rt = parcelRequire("5g4rt");

function $1119aafb00a8a88b$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $42omo.useContext)((0, $5g4rt.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $42omo.useContext)((0, $6mnSH.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $42omo.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $42omo.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
   * - radio state changes any time a radio child is changed
   * - when it changes we want all radio buttons to update their local state
   * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
   */ (0, $42omo.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    /**
   * Set the initial state of the context provider's store,
   * if it doesn't already have a persisted value for this id.
   */ if (persistedIsSelected === undefined) {
        const existing = getGroupState(group);
        const newGroupState = {
            ...existing,
            [id]: defaultSelected || false
        };
        setGroupState(group, newGroupState);
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $1119aafb00a8a88b$export$2e2bcd8739ae039 = $1119aafb00a8a88b$var$useRadioState;
module.exports["default"] = $1119aafb00a8a88b$export$2e2bcd8739ae039;

});

parcelRegister("6mnSH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $ea384564884ae281$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $42omo.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $ee7An.default)
});
module.exports["RadioGroupContext"] = $ea384564884ae281$export$a79eda4ff50e30b6;

});


//# sourceMappingURL=CompanyHubMainLayout.11ff6518.js.map
